export const ZOOM_MIN = -2;
export const ZOOM_MAX = 4;
export const ZOOM_STEP = 0.1;
export const BASE_ROW_HEIGHT = 55;
export const BASE_HEADER_HEIGHT = 45;
export const BASE_FONT_PX = 14;

export const clampZoom = (level: number): number =>
  Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, Math.round(level)));

export const getZoomScale = (level: number): number => 1 + clampZoom(level) * ZOOM_STEP;

export const getZoomedRowHeight = (level: number): number =>
  Math.round(BASE_ROW_HEIGHT * getZoomScale(level));

export const getZoomedHeaderHeight = (level: number): number =>
  Math.round(BASE_HEADER_HEIGHT * getZoomScale(level));

export const getZoomedFontSize = (level: number): string =>
  `${(BASE_FONT_PX * getZoomScale(level)) / 16}rem`;
